import { Table, TableBody, TableCell, TableHead, TableRow } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type CommonImporterError } from './CommonImporterErrorStage'
import { ImporterErrorGroup } from './ImporterErrorGroup'
import { ImporterErrorListStyled } from './styles/ImporterErrorListStyled'
import messages from '../../messages'

export interface IImporterErrorListProps {
  errors: CommonImporterError[][]
}

export const ImporterErrorList = ({ errors }: IImporterErrorListProps) => {
  const intl = useProcurifyIntl()

  return (
    <ImporterErrorListStyled>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell width='8%' colSpan={2} />
            <TableCell width='12%'>
              {intl.formatMessage(messages.errorListRowLabel)}
            </TableCell>
            <TableCell width='20%'>
              {intl.formatMessage(messages.errorListColumnLabel)}
            </TableCell>
            <TableCell width='20%'>
              {intl.formatMessage(messages.errorListValueLabel)}
            </TableCell>
            <TableCell width='40%'>
              {intl.formatMessage(messages.errorListErrorLabel)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody hoverable={false} zebra={false}>
          {errors.map((errorGroup, key) => (
            <ImporterErrorGroup errorGroup={errorGroup} key={key} />
          ))}
        </TableBody>
      </Table>
    </ImporterErrorListStyled>
  )
}
